import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-excel.svg'


const _withScopeId = n => (_pushScopeId("data-v-0b76d038"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full pt-[100px] px-8 pb-12 gap-4" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[16px]" }, "Dividendos", -1))
const _hoisted_4 = { class: "flex gap-5 lg:items-center items-start lg:flex-row flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-[16px]" }, "Excel", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-row px-4 items-center justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row w-3/6 justify-center items-center p-4"
}
const _hoisted_10 = { class: "flex flex-col sm:rounded-lg sm:border sm:border-gray-200 sm:shadow-lg sm:p-6 overflow-auto w-full" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left border-b border-gray-200 px-4 py-4" }, " N° de dividendo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left border-b border-gray-200 px-4 py-4" }, " Fechas de corte "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left border-b border-gray-200 px-4 py-4" }, " Fecha de distribución "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left border-b border-gray-200 px-4 py-4" }, " Tipo de dividendo "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right border-b border-gray-200 px-4 py-4" }, " UF por acción "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right border-b border-gray-200 px-4 py-4" }, " Cant. acciones "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right border-b border-gray-200 px-4 py-4" }, " Cant. accionistas "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right border-b border-gray-200 px-4 py-4" }, " Total pagado "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center border-b border-gray-200 px-4 py-4" }, " Acciones ")
  ])
], -1))
const _hoisted_12 = { class: "overflow-auto" }
const _hoisted_13 = { class: "text-left px-4 py-4" }
const _hoisted_14 = { class: "text-left px-4 py-4" }
const _hoisted_15 = { class: "text-left px-4 py-4" }
const _hoisted_16 = { class: "text-center px-4 py-4 font-semibold" }
const _hoisted_17 = { class: "text-right px-4 py-4" }
const _hoisted_18 = { class: "text-right px-4 py-4" }
const _hoisted_19 = { class: "text-right px-4 py-4" }
const _hoisted_20 = { class: "text-right px-4 py-4" }
const _hoisted_21 = { class: "flex flex-row items-center justify-center gap-2 w-full" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-7" }, [
  /*#__PURE__*/_createTextVNode(" Esta acción borrara definitivamente este dividendo. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¿ Desea continuar con la acción ? ")
], -1))

import { onMounted, ref, watch, Ref } from "vue";

import { DividendService } from "@/services/dividends/dividendService";
import {
  PaymentStatus,
  DividendType,
  formOptionsType,
  DividendsFilter,
  DividendStatusType,
  MultiplePaymentsData,
} from "@/services/dividends/types";
import { formatNumber, reformatDate, toBadgeFormat } from "@/services/utils";

import Modal from "@/components/atoms/Modal.vue";
import Selector from "@/components/atoms/Selector.vue";
import NewPaginationTableComponent from "@/components/molecules/NewPaginationTableComponent.vue";
import DividendDetailModal from "@/components/organisms/dividends/DividendDetailModal.vue";
import GenericDividensForm from "@/components/organisms/dividends/GenericDividendsForm.vue";
import EditDividendModal from "@/components/organisms/dividends/EditDividendModal.vue";
import PaginationControl from "@/components/atoms/PaginationControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DividendsView',
  setup(__props) {

const columnsDividendos = ref([
  { name: "code", label: "N° de dividendo" },
  { name: "cutoffDate", label: "Fecha de corte" },
  { name: "distributionDate", label: "Fecha de distribución" },
  { name: "divTypeString", label: "Tipo de dividendo" },
  { name: "ufPerShare", label: "Uf por acción" },
  { name: "totalShares", label: "Cant. acciones" },
  { name: "totalShareholders", label: "Cant. accionistas" },
  { name: "totalPayedClp", label: "Total pagado" },
]);

const dividendService = new DividendService();
const dividendNewStatus = ref<DividendStatusType>(DividendStatusType.PENDING);

const selectedDividendToDelete = ref<number>();
const showNewDividendModal = ref<boolean>(false);
const isVisibleConfirmationModal = ref<boolean>(false);
const showDetailModal = ref<boolean>(false);
const showFilterModal = ref<boolean>(false);
const dividendPayments = ref<PaymentStatus[]>([]);
const selectedDividendPayments = ref<number[]>([]);
const areAllDividendsSelected = ref<boolean>(false);
const dividendDataSelected = ref<PaymentStatus>();
const dividendFilter = ref<DividendsFilter>(new DividendsFilter());

const currentPage: Ref<number> = ref(1);
const totalPages: Ref<number> = ref(0);
const perPage: Ref<number> = ref(0);

const dividends = ref<DividendType[]>([]);

/* */
const dividendEditModal = ref(false);

const otherCurrentPage = (newPage: number) => {
  currentPage.value = newPage;
  getAllDividends(currentPage.value);
};

async function getAllDividends(page = 0) {
  let res = await dividendService.getAllDividends(page);
  if (!res.success) {
    alert(
      "Ha ocurrido un error al cargar los dividendos. Vuelve a intentarlo."
    );
    dividends.value = [];
    return false;
  }
  if (res.success) {
    dividends.value = res.data;
    currentPage.value = res.page;
    totalPages.value = res.total_pages;
    perPage.value = res.per_page;

    dividends.value.forEach((dividend) => {
      dividend.cutoffDate = reformatDate(dividend.cutoffDate.toString());
      dividend.totalPayedClp =
        "$" +
        toBadgeFormat(
          parseInt(dividend?.totalPayedClp?.toString() ?? "0") ?? 0
        );
      dividend.distributionDate = reformatDate(
        dividend.distributionDate.toString()
      );
      dividend.ufPerShare =
        dividend.divType.toString() == "UF_PER_SHARE"
          ? dividend.ufPerShare
          : "-";
      dividend.divTypeString =
        dividend.divType.toString() == "UF_PER_SHARE"
          ? "UF por Acción"
          : "Valor total";
    });

    dividends.value = dividends.value.sort((dividend1, dividend2) => {
      return (
        new Date(dividend2.distributionDate).getTime() -
        new Date(dividend1.distributionDate).getTime()
      );
    });
  }
}

async function getDividents() {
  /*const response = await dividendService.getDividendPayments();
      if (!response.success) {
        dividendPayments.value = [];
        return;
      }

      dividendPayments.value = response.data;

      dividendPayments.value = dividendPayments.value.sort(
        (dividend1, dividend2) => {
          return (
            new Date(dividend2.pendingDate).getTime() -
            new Date(dividend1.pendingDate).getTime()
          );
        }
      );
      dividendPayments.value = dividendPayments.value.map((dividend) => {
        let newRow = {
          ...dividend,
          pendingDate: reformatDate(
            dividend.pendingDate.toString(),
            true,
            false
          ),
          totalClpStringFormat: dividend.totalClp
            ? "$ " + toBadgeFormat(dividend.totalClp)
            : "-",
          statusStringFormat: dividend.status
            ? getPrettyPrintStatus(dividend.status)
            : "-",
        };

        return newRow;
      });*/
}

watch(areAllDividendsSelected, () => {
  if (areAllDividendsSelected.value) {
    let selectAllFromDate = dividendPayments.value.map((dividend) => {
      return dividend.id;
    });
    selectedDividendPayments.value = selectAllFromDate;
  } else {
    selectedDividendPayments.value = [];
  }
});

async function aplyFilter(dividendFilter: DividendsFilter) {
  await getDividents();
  if (dividendFilter.dateRange != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividend) => {
      if (dividendFilter.dateRange != undefined) {
        return (
          dividendFilter.dateRange[0] <= new Date(dividend.pendingDate) &&
          new Date(dividend.pendingDate) <= dividendFilter.dateRange[1]
        );
      }
    });
  }
  if (dividendFilter.filterDate != undefined) {
    const filterDateString = dividendFilter.filterDate
      .toISOString()
      .split("T")[0];

    dividendPayments.value = dividendPayments.value.filter((dividend) => {
      const dividendDate = new Date(dividend.pendingDate);
      const dividendDateString = dividendDate.toISOString().split("T")[0];

      if (filterDateString === dividendDateString) {
        return true;
      }
      return false;
    });
  }
  if (dividendFilter.shareholderId != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.shareholderId == dividendFilter.shareholderId;
    });
  }
  if (!dividendFilter.showPayed) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.PAID;
    });
  }
  if (!dividendFilter.showPending) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.PENDING;
    });
  }
  if (!dividendFilter.showRejected) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.status != DividendStatusType.REJECTED;
    });
  }
  if (dividendFilter.dividendId != undefined) {
    dividendPayments.value = dividendPayments.value.filter((dividen) => {
      return dividen.dividendId == dividendFilter.dividendId;
    });
  }
}

const updateSelectedItems = (selected: any) => {
  alert("actualizando los seleccionados");

  selectedDividendPayments.value = selected;
  // selectedItems.value = selected;
};

async function modifyMultiplePayments() {
  const multiplePaymentData = new MultiplePaymentsData(
    selectedDividendPayments.value,
    dividendNewStatus.value
  );
  const res = await dividendService.editMultiplePayment(multiplePaymentData);
  if (!res.data) {
    alert("Ocurrio un error inesperado");
  }
  alert("Se ha cambiado el estado de los pagos seleccionados de forma exitosa");
  selectedDividendPayments.value = [];
  areAllDividendsSelected.value = false;
  dividendFilter.value = new DividendsFilter();
  aplyFilter(dividendFilter.value);
  //getDividents();
}
async function deleteHandler(dividendId: number, e: Event) {
  e.stopPropagation();
  isVisibleConfirmationModal.value = true;
  selectedDividendToDelete.value = dividendId;
}
async function deleteDividend() {
  dividendFilter.value = new DividendsFilter();
  aplyFilter(dividendFilter.value);
  if (selectedDividendToDelete.value == undefined) return null;
  let res = await dividendService.deleteDividend(
    selectedDividendToDelete.value
  );
  if (res.success) {
    alert("dividendo eliminado con éxito.");
  }
  getAllDividends(currentPage.value);
  //getDividents();
  isVisibleConfirmationModal.value = false;
}

function filterDividendHandler(dividendId: number, e: Event) {
  if (dividendId == -1) {
    dividendFilter.value = new DividendsFilter();
    aplyFilter(dividendFilter.value);

    return false;
  }
  e.stopPropagation();
  dividendFilter.value.dividendId = dividendId;

  aplyFilter(dividendFilter.value);
}

function tableRowSelectionHandler(dividendSelected: PaymentStatus) {
  dividendDataSelected.value = dividendSelected;
  showDetailModal.value = true;
}
function closeFilterModal() {
  showFilterModal.value = showFilterModal.value ? false : showFilterModal.value;
}
function closeNewDividendModal() {
  showNewDividendModal.value = showNewDividendModal.value
    ? false
    : showNewDividendModal.value;
}
function closeNewDetailModal() {
  //dontRepit yourself
  showDetailModal.value = showDetailModal.value ? false : showDetailModal.value;
}

function getPrettyPrintStatus(status: DividendStatusType) {
  switch (status) {
    case DividendStatusType.PAID:
      return "Pagado";
    case DividendStatusType.PENDING:
      return "Pendiente";
    case DividendStatusType.REJECTED:
      return "Rechazado";
    default:
      break;
  }
  return status;
}

function genericButtonHandler(option: formOptionsType) {
  showNewDividendModal.value = false;
  showFilterModal.value = false;
  switch (option) {
    case formOptionsType.newDividendForm:
      showNewDividendModal.value = true;
      break;

    case formOptionsType.filterForm:
      showFilterModal.value = true;
      break;

    default:
      break;
  }
}

function downloadExcel() {
  dividendService.downloadDividendsList();
}

onMounted(async () => {
  getAllDividends(currentPage.value);
  //getDividents();
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "bg-white text-[#5F5F5F] btn btn-excel w-[124px] h-[33px] flex gap-2 text-sm items-center justify-center",
            onClick: downloadExcel
          }, _hoisted_7),
          _createElementVNode("button", {
            class: "h-[34px] btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (genericButtonHandler(_unref(formOptionsType).newDividendForm)))
          }, " Agregar nuevo dividendo ")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          (selectedDividendPayments.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(Selector, {
                  values: [
              _unref(DividendStatusType).PAID,
              _unref(DividendStatusType).PENDING,
              _unref(DividendStatusType).REJECTED,
            ],
                  items: [
              getPrettyPrintStatus(_unref(DividendStatusType).PAID),
              getPrettyPrintStatus(_unref(DividendStatusType).PENDING),
              getPrettyPrintStatus(_unref(DividendStatusType).REJECTED),
            ],
                  model: dividendNewStatus.value,
                  "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((dividendNewStatus).value = $event)),
                  class: "w-3/6"
                }, null, 8, ["values", "items", "model"]),
                _createElementVNode("button", {
                  class: "success btn m-2",
                  onClick: modifyMultiplePayments
                }, " Actualizar ")
              ]))
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createElementBlock("aside", {
            id: "newDividend",
            class: _normalizeClass(["absolute lg:w-1/5 w-4/5 top-[90px] z-20 rounded-xl border right-[2em] bg-white shadow-lg", showNewDividendModal.value ? 'flex' : 'hidden'])
          }, [
            _createVNode(GenericDividensForm, {
              formOptionSelected: _unref(formOptionsType).newDividendForm,
              onCloseModals: closeNewDividendModal,
              onGetDivident: getDividents,
              onGetAllDividends: getAllDividends
            }, null, 8, ["formOptionSelected"])
          ], 2)), [
            [_directive_click_outside, closeNewDividendModal]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("aside", {
            id: "filter",
            class: _normalizeClass(["absolute w-5/6 lg:w-1/6 top-[90px] z-20 rounded-xl border right-[7em] bg-white shadow-lg", showFilterModal.value ? 'flex' : 'hidden'])
          }, [
            _createVNode(GenericDividensForm, {
              formOptionSelected: _unref(formOptionsType).filterForm,
              onCloseModals: closeFilterModal,
              onAplyFilter: aplyFilter
            }, null, 8, ["formOptionSelected"])
          ], 2)), [
            [_directive_click_outside, closeFilterModal]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", null, [
          _hoisted_11,
          _createElementVNode("tbody", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dividends.value, (dividend, dividendIndex) => {
              return (_openBlock(), _createElementBlock("tr", { key: dividendIndex }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(dividend.code ?? "-"), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(dividend.cutoffDate ?? "-"), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(dividend.distributionDate ?? "-"), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(dividend.divTypeString ?? "-"), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(+dividend.ufPerShare ? _unref(formatNumber)(+dividend.ufPerShare) : "-"), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(dividend.totalShares ?? "-"), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(dividend.totalShareholders ?? "-"), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(dividend.totalPayedClp ?? "-"), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "flex flex-row items-center",
                      onClick: 
                    () => {
                      dividendDataSelected.value = dividend;
                      dividendEditModal.value = true;
                    }
                  
                    }, [
                      _createVNode(_component_mdicon, {
                        name: "pencil",
                        class: "text-gray-500"
                      })
                    ], 8, _hoisted_22),
                    _createVNode(_component_router_link, {
                      class: "flex flex-row items-center",
                      to: { name: 'dividends-id', params: { id: dividend.id } }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_mdicon, {
                          name: "eye",
                          class: "text-gray-500"
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("button", {
                      class: "flex flex-row items-center",
                      type: "button",
                      onClick: (e) => deleteHandler(dividend.id, e)
                    }, [
                      _createVNode(_component_mdicon, {
                        name: "delete",
                        class: "text-gray-500"
                      })
                    ], 8, _hoisted_23)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(PaginationControl, {
        "selected-page": currentPage.value,
        "per-page": perPage.value,
        "total-pages": totalPages.value,
        onSetPage: otherCurrentPage
      }, null, 8, ["selected-page", "per-page", "total-pages"])
    ]),
    (_openBlock(), _createBlock(Modal, {
      id: "modal 1",
      key: 1,
      title: "Confirmación",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value))
    }, {
      default: _withCtx(() => [
        _hoisted_24
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "bg-button-green shadow-md text-white",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteDividend()))
        }, " Aceptar ")
      ]),
      _: 1
    }, 8, ["visible"])),
    (showDetailModal.value)
      ? (_openBlock(), _createBlock(DividendDetailModal, {
          key: 0,
          visible: showDetailModal.value,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showDetailModal).value = $event)),
          dividend: dividendDataSelected.value,
          onClose: closeNewDetailModal,
          onUpdate: getDividents,
          class: "z-10"
        }, null, 8, ["visible", "dividend"]))
      : _createCommentVNode("", true),
    _createVNode(EditDividendModal, {
      visible: dividendEditModal.value,
      onClose: _cache[5] || (_cache[5] = () => (dividendEditModal.value = false)),
      "dividend-data": dividendDataSelected.value,
      onRefetch: _cache[6] || (_cache[6] = () => getAllDividends(currentPage.value))
    }, null, 8, ["visible", "dividend-data"])
  ], 64))
}
}

})